import css from 'styled-jsx/css';

const vars = css.global`
  :root {
    --pageBgColor: #f2f2f2;
  }
`;
export default vars;
